import { all, takeLatest } from 'redux-saga/effects';

import { Types as ProductTypes } from '../ducks/product';
import { Types as ChatbotTypes } from '../ducks/chatbot';
import { Types as GeolocationTypes } from '../ducks/geolocation';

import { getProducts, sendEmailProducts } from './product';
import { setChatbotSaga, postChatbot } from './chatbot';
import { getGeolocation } from './geolocation';

export default function* rootSaga() {
  return yield all([
    takeLatest(ProductTypes.GET_PRODUCTS, getProducts),
    takeLatest(ProductTypes.SEND_EMAIL_PRODUCTS, sendEmailProducts),
    takeLatest(ChatbotTypes.SET_CHATBOT_SAGA, setChatbotSaga),
    takeLatest(ChatbotTypes.POST_CHATBOT, postChatbot),
    takeLatest(GeolocationTypes.GET_GEOLOCATION, getGeolocation),
  ]);
}